import { observer } from "mobx-react-lite";
import { AudioCaptureIndicator } from "@/components/layout/components/audio-capture";
import { VoiceActions } from "@/components/note/floating-actions/voice-actions";
import { MemCommonEditorStore } from "@/components/note/store/mem-common-editor-store";
import { MDSIconKind, MDSPopover } from "@/mds";
import { useVoiceIndicatorBehavior } from "@/components/note/editor/top-bar/indicators/voice-indicator/voice-indicator.hooks";
import { AudioRecordingObservable } from "@/store/audio-recordings";
import { AnyNoteVoiceSuggestion } from "@/store/note";

interface VoiceIndicatorProps {
  audioRecording?: AudioRecordingObservable | null;
  noteSuggestion?: AnyNoteVoiceSuggestion | null;
  editorStore: MemCommonEditorStore;
}

export const VoiceIndicator = observer(
  ({ audioRecording, noteSuggestion, editorStore }: VoiceIndicatorProps) => {
    const { handleRequestClose, ref, setIsOpen, isOpen, popoverContentRef } =
      useVoiceIndicatorBehavior({
        noteId: editorStore.id,
        audioRecording,
        isSuggestionActive: Boolean(editorStore.noteObservable?.isSuggestionActive),
      });

    const handleClick = () => {
      setIsOpen(isOpen => !isOpen);
    };

    return (
      <>
        <AudioCaptureIndicator
          ref={ref}
          insideNote={true}
          onClick={handleClick}
          rightIconKind={isOpen ? MDSIconKind.AngleDown : MDSIconKind.AngleUp}
          audioRecording={audioRecording}
          noteSuggestion={noteSuggestion}
        />
        {editorStore && (
          <MDSPopover
            styling={false}
            triggerRef={ref}
            isOpen={isOpen}
            onOpenChange={setIsOpen}
            isNonModal={true}
            // When clicking on the indicator button, let it close the popover.
            shouldCloseOnInteractOutside={el => !el.contains(ref.current)}
          >
            <div
              data-voice-actions-root
              ref={popoverContentRef}
              tabIndex={-1}
              style={{ outline: "none" }}
            >
              <VoiceActions editorStore={editorStore} onRequestClose={handleRequestClose} />
            </div>
          </MDSPopover>
        )}
      </>
    );
  }
);
